import gql from "graphql-tag"

const GET_INCOMING_STOCK = gql`
  query GetIncomingStock($productVariantId: String!) {
    getIncomingStock(productVariantId: $productVariantId) {
      id
      quantity
      incomingStockDate
      incomingStockQuantity
    }
  }
`

export default GET_INCOMING_STOCK
